import daylightSavingTimezoneOffset from '../daylight-saving-timezone-offset';

const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    month: 'numeric',
    second: 'numeric',
    timeZone: 'Europe/Berlin',
    year: 'numeric'
};

const berlinTime = (locale: string | undefined = undefined) => new Date().toLocaleString(locale, options);

export const berlinTimeInMiliseconds = () => {
    const today = new Date();
    const offsetFromBerlinInHours = today.getTimezoneOffset() / 60 + daylightSavingTimezoneOffset(); // +2 in summertime and +1 in winter time
    const offsetFromBerlinInMiliseconds = offsetFromBerlinInHours * 3600000;
    const currentBerlinTimeInMiliseconds = today.getTime() - offsetFromBerlinInMiliseconds;

    return {
        currentBerlinTimeInMiliseconds,
        offsetFromBerlinInMiliseconds
    };
};

export const isThisTimeFrameInBerlinNow = (start: Date, end: Date) => {
    const today = new Date();
    const { offsetFromBerlinInMiliseconds } = berlinTimeInMiliseconds();
    const berlinStartMiliseconds = start.getTime() - offsetFromBerlinInMiliseconds;
    const berlinEndMiliseconds = end.getTime() - offsetFromBerlinInMiliseconds;
    const currentMiliseconds = today.getTime();

    return currentMiliseconds > berlinStartMiliseconds && currentMiliseconds < berlinEndMiliseconds;
};

export default berlinTime;
